import cn from "clsx"
import { Typography } from "@callcenter/design-system"
import { t } from "i18next"

import { useAdminMenuItems } from "./navigation-admin.hooks"
import { isAdminMenuItemActive } from "./navigation-admin.helpers"

import styles from "./navigation-admin.module.pcss"
import sharedStyles from "../../shared/styles.module.pcss"

export const NavigationAdmin = () => {
  const menuItems = useAdminMenuItems()

  if (menuItems.length === 0) {
    return null
  }

  return (
    <div
      className={cn(sharedStyles.menuGroup, styles.menuGroup, {
        [sharedStyles.active]: menuItems.some(isAdminMenuItemActive)
      })}
    >
      <Typography.TopHeader>{t("mainMenuBar_adminMenu_mainMenuLabel_adminMenuLabel")}</Typography.TopHeader>
      <div className={sharedStyles.dropdownMenu}>
        {menuItems.map((menuItem) => (
          <Typography.TopHeader
            as="a"
            href={menuItem.path}
            key={menuItem.path}
            className={cn(sharedStyles.menuItem, { [sharedStyles.active]: isAdminMenuItemActive(menuItem) })}
          >
            {menuItem.label}
          </Typography.TopHeader>
        ))}
      </div>
    </div>
  )
}
